<template>
  <div>
    <el-upload
      action="image/upload-img-files"
      :disabled="disabled"
      list-type="picture-card"
      accept=".jpg,.png,.jpeg,.gif,.JPG,.PNG,.JPEG,.GIF"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :on-change="handleChange"
      :file-list="fileList"
      :http-request="upload"
      style="width: 460px;display: inline;"
      :limit="limit"
      :on-exceed="handleExceed"
      :on-success="handleSuccess"
      :on-error="handleError"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
const DomTheOrder= {
  "doorFacePic": 0,
  "shopInPic": 1,
  "licensePic": 2
}
export default {
  name: 'store-img-upload',
  props: {
    imgUrls: Array || String,
    disabled: Boolean,
    limit: {
      type: Number,
      default() {
        return 3
      }
    },
    type: String
  },
  watch: {
    imgUrls: {
      immediate: true,
      handler: function(val) {
        if(this.type === 'licensePic' && val) {
          this.fileList = [{name: val, url: val}]
        }
        else if(val && val.length) {
          this.fileList = val.map(v => {
            return { name: v, url: v }
          })
        }
        this.num= this.fileList.length
      }
    },
    num: {
      immediate: true,
      handler: function(val) {
        this.$nextTick(()=> {
          if(this.disabled === false) {
            try {
              if(val && val=== this.limit){
                document.querySelectorAll('.el-upload--picture-card')[DomTheOrder[this.type]].style.display="none"
              }else if(val!== this.limit){
                document.querySelectorAll('.el-upload--picture-card')[DomTheOrder[this.type]].style.display=""
              }
            } catch (error) {
              console.log(error);
            }
          }
        })
      }
    }
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      upFile: {},
      num: 0
    };
  },
  methods: {
    handleChange(file, fileList) {
      this.upFile= file
    },
    handleRemove(file, fileList) {
      let data= fileList.map(v=> v.url)
      this.num= data.length
      this.$emit('fileList', data)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(res, file, fileList) {
      const {ret, message} = res
      if(ret) {
        fileList[fileList.indexOf(file)].url= res.data.imgUrl;
        let data= fileList.map(v=> v.url)
        this.num= data.length
        this.$emit('fileList', data)
      }else{
        fileList.splice(fileList.indexOf(file), 1)
        this.$message({
          type: "warning",
          message: message || "网络异常，请重新上传"
        })
      }
      
    },
    async upload() {
      let { raw, name }= this.upFile
      if(raw.size/1000/1000 > 5) {
        return { ret: 0, message: "上传图片需小于5M" }
      }
      let formData = new FormData();
      formData.append('files', raw, name)
      return await _api.store.uploadImgFiles(formData);
    },
    handleExceed() {
      this.$message({
        type: 'warning',
        message: `最多上传${this.limit}张照片`
      })
    },
    handleError() {
    }
  }
};
</script>